const initialState = {}

const filterData = function (state = initialState, action) {
	switch (action.type) {
		case "SET_FILTER_DATA":
			return action.payload;
		default:
			return state;
	}
};

export default filterData